import { omit } from 'ramda';
import { forwardRef, MouseEvent, MouseEventHandler } from 'react';
import { A, Box, FelaCSS } from '@bridebook/ui';
import componentStyles from './custom-click-link.style';

export interface ISharedTypes {
  underlined?: boolean;
  linkStyle?: FelaCSS;
}

interface IProps extends ISharedTypes {
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  onCustomClick?: MouseEventHandler<HTMLAnchorElement>;
  href?: string;
  children?: React.ReactNode;
  dataTest?: string;
}

const CustomClickLink = forwardRef<any, IProps>((props, ref) => {
  const { onClick, onCustomClick, underlined, linkStyle } = props;

  const handleClick = (event: MouseEvent<HTMLAnchorElement>): void => {
    if (onClick) {
      onClick(event);
    }

    if (onCustomClick) {
      onCustomClick(event);
    }
  };

  const explicitProps = omit(['onCustomClick', 'underlined', 'linkStyle'], props);

  const styles = componentStyles({ underlined });

  return (
    <Box style={styles.wrapper}>
      <A
        {...explicitProps}
        style={{ display: 'block', ...linkStyle }}
        onClick={handleClick}
        noUnderline
        ref={ref}
      />
    </Box>
  );
});

export default CustomClickLink;
